module.exports = __webpack_public_path__ + "img/highlight1_v2.f087d157.png";